import React from "react";
import { Dialog, Grid } from "@mui/material";
import FAQ from "./UI/FAQ";
import { FAQQuestions1, FAQQuestions2 } from "../utils/constants";
interface Props {
  openFAQModal: boolean;
  closeFAQModal: () => void;
}

function FAQModal(props: Props) {
  const { closeFAQModal, openFAQModal } = props;

  return (
    <Dialog open={openFAQModal} onClose={closeFAQModal} fullWidth maxWidth="md">
      <Grid container spacing={5} padding={5}>
        <Grid item xs={6}>
          {FAQQuestions1.map((faq) => (
            <FAQ
              key={faq.question}
              answer={faq.answer}
              question={faq.question}
            />
          ))}
        </Grid>
        <Grid item xs={6}>
          {FAQQuestions2.map((faq) => (
            <FAQ
              key={faq.question}
              answer={faq.answer}
              question={faq.question}
            />
          ))}
        </Grid>
      </Grid>
    </Dialog>
  );
}

export default FAQModal;
